// extracted by mini-css-extract-plugin
export default {"online":"GadgetInstallButton_online__q7vFC","offline":"GadgetInstallButton_offline__2PVe9","installButton":"GadgetInstallButton_installButton__ghgi5"};